import $ from 'jquery'
import {
  objectKeysToCamelCase,
  objectKeysToSnakeCase
} from '../../common/case-style-conversion'

async function _request(filter, requestType) {
  const urlParameter = filter.id ? filter.id + '/' : ''
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${filter.url}/${urlParameter}`,
      contentType: 'application/json',
      type: requestType,
      data: JSON.stringify(objectKeysToSnakeCase(filter.toObject())),
      dataType: 'json',
      success: resolve,
      error: reject
    })
      .done(res => resolve(objectKeysToCamelCase(res)))
      .fail(err => reject(err.statusText))
  })
}

export const createNotification = async filter => await _request(filter, 'POST')

export const updateNotification = async filter => await _request(filter, 'PATCH')

export const deleteNotification = async filter => await _request(filter, 'DELETE')
